import React from 'react'
import "./deleteSiteModal.css"
const typeSitesMapping = {
  1: "Hangar",
  2: "Warehouse",
  // 3: "Bonded Warehouse",
  4: "Line Maintenance",
  5: "Shop",
  6: "Vendor Managed"
};
export const DeleteSiteModal = ({ onClose, siteName, siteType, deleteSite }) => {
  const handleDelete = () => {
    deleteSite()
    onClose()
  }
  return (
    <section className='delete-site-cont'>
      <h3>Are you sure you want to <br /> delete this Site?</h3>
      <div className="delete-site-pCont">
        <p>Site: <span>{siteName}</span></p>
        <p>Type: <span>{siteType}</span></p>
      </div>
      <div className='delete-site-btnCont'>
        <button onClick={handleDelete}>Ok</button>
        <button onClick={onClose}>Cancel</button>
      </div>
    </section>
  )
}
